module.exports = __webpack_public_path__ + "static/second_user_image1-e9c566075487f1af87071b2694591c23.jpg";